import React, { FC, useState } from 'react';
import { formatDate } from 'utils/format';
import { useTranslation } from 'react-i18next';
import { Box, Button, IconButton, Paper, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { ScannerCase } from 'models/scanner-case';
import { currentOrgVar } from 'apollo/reactive-variables/organization';
import ScannerCaseDialog from 'components/scanner-cases/shared/scanner-case-dialog/scanner-case-dialog.component';
import { ActionOrderInput } from 'models/order-input/action-order';

type ScannerCaseItemProps = {
    order: ActionOrderInput;
    scannerCase: ScannerCase;
    onOpenUnlinkDialog?: (scannerCaseId: string) => void;
};
const ScannerCaseItem: FC<ScannerCaseItemProps> = ({ order, scannerCase, onOpenUnlinkDialog }) => {
    const { t: translate } = useTranslation(['orders']);
    const [isScanCaseDialogOpen, setIsScanCaseDialogOpen] = useState(false);
    const currentOrganization = currentOrgVar();

    const onScanCaseDialogClose = () => {
        setIsScanCaseDialogOpen(false);
    };

    const unlinkAttachment = () => {
        if (onOpenUnlinkDialog) {
            onOpenUnlinkDialog(scannerCase._id);
        }
    };

    return (
        <Paper variant="outlined" sx={{ marginBottom: 1, borderRadius: 2, display: 'flex', alignItems: 'center' }}>
            <Box flex="1 0 auto" p={1}>
                <Box sx={{ fontWeight: 'bold' }}>
                    <Typography variant="subtitle2">
                        {scannerCase.patient?.firstName} {scannerCase.patient?.lastName} -{' '}
                        {formatDate(scannerCase.updatedAt, 'datetime')}
                    </Typography>
                </Box>
                <Box>
                    <Typography variant="body2" color="#555">
                        {translate(`scan-cases:${scannerCase.source}`)}, {scannerCase.displayCaseId}
                    </Typography>
                </Box>
            </Box>
            <Box flex="0 0 auto" p={1} sx={{ textAlign: 'right' }}>
                <Box>
                    <Button
                        onClick={() => setIsScanCaseDialogOpen(true)}
                        data-test="three-shape-attachments.show-case-btn"
                    >
                        {translate('orders:SHOW_CASE_AND_DOWNLOAD_FILES')}
                    </Button>
                </Box>
                {scannerCase.organization._id === currentOrganization._id ? (
                    <Box>
                        <IconButton
                            onClick={unlinkAttachment}
                            aria-label="remove"
                            size="small"
                            data-test="three-shape-attachments.unlink-scan-case-btn"
                        >
                            <DeleteIcon />
                        </IconButton>
                    </Box>
                ) : undefined}
            </Box>

            <ScannerCaseDialog
                open={isScanCaseDialogOpen}
                caseId={scannerCase._id}
                onDialogClose={onScanCaseDialogClose}
            />
        </Paper>
    );
};

export default ScannerCaseItem;
